<template>
  <v-layout row wrap class="display-field mx-0 mt-0 mb-4"
    v-if="content">
    <v-flex xs12 class="mb-2 display-field-label">
      <v-icon v-if="icon" small color="primary lighten-1" class="material-symbols-rounded">{{icon}}</v-icon>
      {{ label }}
    </v-flex>
    <v-card flat color="grey-3">
      <v-card-text class="display-field-text">
        {{ content }}
      </v-card-text>
    </v-card>
  </v-layout>
</template>
<script>
export default {
  props: {
    label: String,
    content: null,
    icon: String,
  },
}
</script>
<style lang="scss" scoped>
.display-field {
  .v-icon {
    font-size: 18px !important;
  }
  .v-card {
    width: 100%;
    border-radius: 10px;
  }
  .v-card-text {
    padding: 16px 18px;
  }
  .display-field-label {
    color: var(--v-dark-text-base);
    font-family: "Mukta Mahee";
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0.25px;
  }
  .display-field-text {
    color: var(--v-dark-text-base);
    font-family: "Mukta Mahee";
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
  }
}
</style>